<template>
  <v-dialog v-model="dialog" scrollable width="1000">
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>
    <v-card flat color="white" v-if="selectedCompanyRate != null">
      <v-card-title class="dialog-header-title"
        >Manage Company Rates for
        {{ selectedCompanyRate.company.short_name }}</v-card-title
      >
      <v-card-text class="px-0" style="overflow: hidden">
        <v-tabs centered fixed-tabs light>
          <v-tab class="tab-active-class font-weight-bold text-capitalize"
            >Customer Rates</v-tab
          >
          <v-tab class="tab-active-class font-weight-bold text-capitalize"
            >Supplier Rates</v-tab
          >

          <!-- Customer Rates -->
          <v-tab-item>
            <v-card flat color="white">
              <v-card-text style="height: 350px; overflow: auto">
                <v-row no-gutters>
                  <v-col cols="5"></v-col>
                  <v-col cols="3">
                    <span>Assigned customer rank:</span>
                    <v-select
                      class="form-control"
                      :items="customerRanks"
                      item-value="customer_rank_id"
                      item-text="label"
                      flat
                      v-model="selectedCompanyRate.customer_rank_id"
                    ></v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-divider></v-divider>
                </v-row>

                <v-row no-gutters v-if="selectedCompanyRate != null">
                  <v-col>
                    <v-row>
                      <v-col class="pb-2" style="text-align: center; font-weight: bold"
                        >Item</v-col
                      >

                      <v-col class="pb-2" style="text-align: center; font-weight: bold"
                        >Override</v-col
                      >

                      <v-col class="pb-2" style="text-align: center; font-weight: bold"
                        >Overriden value</v-col
                      >
                      <v-col class="pb-2" style="text-align: center; font-weight: bold"
                        >Rank value</v-col
                      >
                    </v-row>

                    <v-row>
                      <v-col class="col-lg-4 div-component" style="text-align: left"
                        >Air freight rate multiplier:</v-col
                      >
                      <v-col style="text-align: center">
                        <input
                          type="checkbox"
                          class
                          id="includeExportClearance"
                          v-model="
                            selectedCompanyRate.markup_info.air_freight_markup_rate
                              .override
                          "
                        />
                      </v-col>
                      <v-col style="text-align: center">
                        <input
                          type="number"
                          class="form-control input-number"
                          v-model.number="
                            selectedCompanyRate.markup_info.air_freight_markup_rate.value
                          "
                          :placeholder="0"
                          :disabled="
                            !selectedCompanyRate.markup_info.air_freight_markup_rate
                              .override
                          "
                        />
                      </v-col>
                      <v-col style="text-align: center">
                        <input
                          type="number"
                          class="form-control input-number"
                          :placeholder="0"
                          v-model.number="
                            selectedCompanyRate.customer_rank.air_freight_markup_rate
                          "
                          readonly
                        />
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col class="col-lg-4 div-component" style="text-align: left"
                        >FCL freight rate multiplier:</v-col
                      >
                      <v-col style="text-align: center">
                        <input
                          type="checkbox"
                          class
                          id="includeExportClearance"
                          v-model="
                            selectedCompanyRate.markup_info.ocean_freight_fcl_markup_rate
                              .override
                          "
                        />
                      </v-col>
                      <v-col style="text-align: center">
                        <input
                          type="number"
                          class="form-control input-number"
                          v-model.number="
                            selectedCompanyRate.markup_info.ocean_freight_fcl_markup_rate
                              .value
                          "
                          :placeholder="0"
                          :disabled="
                            !selectedCompanyRate.markup_info.ocean_freight_fcl_markup_rate
                              .override
                          "
                        />
                      </v-col>
                      <v-col style="text-align: center">
                        <input
                          type="number"
                          class="form-control input-number"
                          :placeholder="0"
                          v-model.number="
                            selectedCompanyRate.customer_rank
                              .ocean_freight_fcl_markup_rate
                          "
                          readonly
                        />
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col class="col-lg-4 div-component" style="text-align: left"
                        >LCL freight rate multiplier:</v-col
                      >
                      <v-col style="text-align: center">
                        <input
                          type="checkbox"
                          class
                          id="includeExportClearance"
                          v-model="
                            selectedCompanyRate.markup_info.ocean_freight_lcl_markup_rate
                              .override
                          "
                        />
                      </v-col>
                      <v-col style="text-align: center">
                        <input
                          type="number"
                          class="form-control input-number"
                          v-model.number="
                            selectedCompanyRate.markup_info.ocean_freight_lcl_markup_rate
                              .value
                          "
                          :placeholder="0"
                          :disabled="
                            !selectedCompanyRate.markup_info.ocean_freight_lcl_markup_rate
                              .override
                          "
                        />
                      </v-col>
                      <v-col style="text-align: center">
                        <input
                          type="number"
                          class="form-control input-number"
                          :placeholder="0"
                          v-model.number="
                            selectedCompanyRate.customer_rank
                              .ocean_freight_lcl_markup_rate
                          "
                          readonly
                        />
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col class="col-lg-4 div-component" style="text-align: left">{{
                        "Insurance processing fee (" +
                        selectedCompanyRate.company.preferred_currency +
                        ")"
                      }}</v-col>
                      <v-col style="text-align: center">
                        <input
                          type="checkbox"
                          class
                          id="includeExportClearance"
                          v-model="
                            selectedCompanyRate.markup_info.insurance_processing_fee
                              .override
                          "
                        />
                      </v-col>
                      <v-col style="text-align: center">
                        <input
                          type="number"
                          class="form-control input-number"
                          :placeholder="0"
                          v-model.number="
                            selectedCompanyRate.markup_info.insurance_processing_fee.value
                          "
                          :disabled="
                            !selectedCompanyRate.markup_info.insurance_processing_fee
                              .override
                          "
                        />
                      </v-col>
                      <v-col style="text-align: center">
                        <input
                          type="number"
                          class="form-control input-number"
                          :placeholder="0"
                          v-model.number="
                            selectedCompanyRate.customer_rank.insurance_processing_fee
                          "
                          readonly
                        />
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col class="col-lg-4 div-component" style="text-align: left"
                        >Transport rate multiplier:</v-col
                      >
                      <v-col style="text-align: center">
                        <input
                          type="checkbox"
                          class
                          id="includeExportClearance"
                          v-model="
                            selectedCompanyRate.markup_info.transport_markup_rate.override
                          "
                        />
                      </v-col>
                      <v-col style="text-align: center">
                        <input
                          type="number"
                          class="form-control input-number"
                          :placeholder="0"
                          v-model.number="
                            selectedCompanyRate.markup_info.transport_markup_rate.rate
                          "
                          :disabled="
                            !selectedCompanyRate.markup_info.transport_markup_rate
                              .override
                          "
                        />
                      </v-col>
                      <v-col style="text-align: center">
                        <input
                          type="number"
                          class="form-control input-number"
                          :placeholder="0"
                          v-model.number="
                            selectedCompanyRate.customer_rank.transport_markup_rate
                          "
                          readonly
                        />
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col class="col-lg-4 div-component" style="text-align: left"
                        >Haulage rate multiplier:</v-col
                      >
                      <v-col style="text-align: center">
                        <input
                          type="checkbox"
                          class
                          id="includeExportClearance"
                          v-model="
                            selectedCompanyRate.markup_info.haulage_markup_rate.override
                          "
                        />
                      </v-col>
                      <v-col style="text-align: center">
                        <input
                          type="number"
                          class="form-control input-number"
                          :placeholder="0"
                          v-model.number="
                            selectedCompanyRate.markup_info.haulage_markup_rate.value
                          "
                          :disabled="
                            !selectedCompanyRate.markup_info.haulage_markup_rate.override
                          "
                        />
                      </v-col>
                      <v-col style="text-align: center">
                        <input
                          type="number"
                          class="form-control input-number"
                          :placeholder="0"
                          v-model.number="
                            selectedCompanyRate.customer_rank.haulage_markup_rate
                          "
                          readonly
                        />
                      </v-col>
                    </v-row>

                    <v-row class="row justify-content-md-center py-1">
                      <v-col class="col-lg-4 div-component" style="text-align: left"
                        >Export forwarding rate multiplier:</v-col
                      >
                      <v-col style="text-align: center">
                        <input
                          type="checkbox"
                          class
                          v-model="
                            selectedCompanyRate.markup_info.fwd_export_markup_rate
                              .override
                          "
                        />
                      </v-col>
                      <v-col style="text-align: center">
                        <input
                          type="number"
                          class="form-control input-number"
                          :placeholder="0"
                          v-model.number="
                            selectedCompanyRate.markup_info.fwd_export_markup_rate.value
                          "
                          :disabled="
                            !selectedCompanyRate.markup_info.fwd_export_markup_rate
                              .override
                          "
                        />
                      </v-col>
                      <v-col style="text-align: center">
                        <input
                          type="number"
                          class="form-control input-number"
                          :placeholder="0"
                          v-model="
                            selectedCompanyRate.customer_rank.fwd_export_markup_rate
                          "
                          readonly
                        />
                      </v-col>
                    </v-row>

                    <v-row class="row justify-content-md-center py-1">
                      <v-col class="col-lg-4 div-component" style="text-align: left"
                        >Import forwarding rate multiplier:</v-col
                      >
                      <v-col style="text-align: center">
                        <input
                          type="checkbox"
                          class
                          v-model="
                            selectedCompanyRate.markup_info.fwd_import_markup_rate
                              .override
                          "
                        />
                      </v-col>
                      <v-col style="text-align: center">
                        <input
                          type="number"
                          class="form-control input-number"
                          :placeholder="0"
                          v-model.number="
                            selectedCompanyRate.markup_info.fwd_import_markup_rate.value
                          "
                          :disabled="
                            !selectedCompanyRate.markup_info.fwd_import_markup_rate
                              .override
                          "
                        />
                      </v-col>
                      <v-col style="text-align: center">
                        <input
                          type="number"
                          class="form-control input-number"
                          :placeholder="0"
                          v-model.number="
                            selectedCompanyRate.customer_rank.fwd_import_markup_rate
                          "
                          readonly
                        />
                      </v-col>
                    </v-row>

                    <v-row class="row justify-content-md-center py-1">
                      <v-col class="col-lg-4 div-component" style="text-align: left">{{
                        "Air handling fee (" +
                        selectedCompanyRate.company.preferred_currency +
                        ")"
                      }}</v-col>

                      <v-col style="text-align: center">
                        <input
                          type="checkbox"
                          class
                          id="includeExportClearance"
                          v-model="
                            selectedCompanyRate.markup_info.air_handling_fee.override
                          "
                        />
                      </v-col>

                      <v-col style="text-align: center">
                        <input
                          type="number"
                          class="form-control input-number"
                          :placeholder="0"
                          v-model.number="
                            selectedCompanyRate.markup_info.air_handling_fee.value
                          "
                          :disabled="
                            !selectedCompanyRate.markup_info.air_handling_fee.override
                          "
                        />
                      </v-col>

                      <v-col style="text-align: center">
                        <input
                          type="number"
                          class="form-control input-number"
                          :placeholder="0"
                          v-model.number="
                            selectedCompanyRate.customer_rank.air_handling_fee
                          "
                          readonly
                        />
                      </v-col>
                    </v-row>

                    <v-row class="row justify-content-md-center py-1">
                      <v-col class="col-lg-4 div-component" style="text-align: left">{{
                        "FCL handling fee (" +
                        selectedCompanyRate.company.preferred_currency +
                        ")"
                      }}</v-col>

                      <v-col style="text-align: center">
                        <input
                          type="checkbox"
                          class
                          id="includeExportClearance"
                          v-model="
                            selectedCompanyRate.markup_info.fcl_handling_fee.override
                          "
                        />
                      </v-col>

                      <v-col style="text-align: center">
                        <input
                          type="number"
                          class="form-control input-number"
                          :placeholder="0"
                          v-model.number="
                            selectedCompanyRate.markup_info.fcl_handling_fee.value
                          "
                          :disabled="
                            !selectedCompanyRate.markup_info.fcl_handling_fee.override
                          "
                        />
                      </v-col>

                      <v-col style="text-align: center">
                        <input
                          type="number"
                          class="form-control input-number"
                          :placeholder="0"
                          v-model.number="
                            selectedCompanyRate.customer_rank.fcl_handling_fee
                          "
                          readonly
                        />
                      </v-col>
                    </v-row>

                    <v-row class="row justify-content-md-center py-1">
                      <v-col class="col-lg-4 div-component" style="text-align: left">{{
                        "LCL handling fee (" +
                        selectedCompanyRate.company.preferred_currency +
                        ")"
                      }}</v-col>

                      <v-col style="text-align: center">
                        <input
                          type="checkbox"
                          class
                          id="includeExportClearance"
                          v-model.number="
                            selectedCompanyRate.markup_info.lcl_handling_fee.override
                          "
                        />
                      </v-col>
                      <v-col style="text-align: center">
                        <input
                          type="number"
                          class="form-control input-number"
                          :placeholder="0"
                          v-model.number="
                            selectedCompanyRate.markup_info.lcl_handling_fee.value
                          "
                          :disabled="
                            !selectedCompanyRate.markup_info.lcl_handling_fee.override
                          "
                        />
                      </v-col>
                      <v-col style="text-align: center">
                        <input
                          type="number"
                          class="form-control input-number"
                          :placeholder="0"
                          v-model.number="
                            selectedCompanyRate.customer_rank.lcl_handling_fee
                          "
                          readonly
                        />
                      </v-col>
                    </v-row>

                    <v-row class="row justify-content-md-center py-1">
                      <v-col class="col-lg-4 div-component" style="text-align: left">{{
                        "Credit line (" +
                        selectedCompanyRate.company.preferred_currency +
                        ")"
                      }}</v-col>

                      <v-col style="text-align: center">
                        <input
                          type="checkbox"
                          class
                          id="includeExportClearance"
                          v-model="selectedCompanyRate.markup_info.credit_line.override"
                        />
                      </v-col>
                      <v-col style="text-align: center">
                        <input
                          type="number"
                          class="form-control input-number"
                          :placeholder="0"
                          v-model.number="
                            selectedCompanyRate.markup_info.credit_line.value
                          "
                          :disabled="
                            !selectedCompanyRate.markup_info.credit_line.override
                          "
                        />
                      </v-col>
                      <v-col style="text-align: center">
                        <input
                          type="number"
                          class="form-control input-number"
                          :placeholder="0"
                          v-model.number="selectedCompanyRate.customer_rank.credit_line"
                          readonly
                        />
                      </v-col>
                    </v-row>

                    <v-row class="justify-content-md-center py-1">
                      <v-col class="col-lg-4 div-component" style="text-align: left">{{
                        "Credit term days"
                      }}</v-col>
                      <v-col style="text-align: center">
                        <input
                          type="checkbox"
                          class
                          id="credittermdays"
                          v-model="
                            selectedCompanyRate.markup_info.credit_term_days.override
                          "
                        />
                      </v-col>
                      <v-col style="text-align: center">
                        <input
                          type="number"
                          class="form-control input-number"
                          :placeholder="0"
                          v-model.number="
                            selectedCompanyRate.markup_info.credit_term_days.value
                          "
                          :disabled="
                            !selectedCompanyRate.markup_info.credit_term_days.override
                          "
                        />
                      </v-col>
                      <v-col style="text-align: center">
                        <input
                          type="number"
                          class="form-control input-number"
                          :placeholder="0"
                          v-model.number="
                            selectedCompanyRate.customer_rank.credit_term_days
                          "
                          readonly
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <!-- Supplier Rates -->
          <v-tab-item>
            <v-card flat color="white">
              <v-card-text style="height: 300px; overflow: auto">
                <v-row no-gutters v-if="selectedCompanyRate != null">
                  <v-col>
                    <v-row>
                      <v-col cols="4">
                        <span>Haulage Fuel Adjustment Factor:</span>
                      </v-col>
                      <v-col cols="2">
                        <input
                          type="number"
                          class="form-control"
                          v-model="selectedCompanyRate.haulage_fuel_adjustment_factor"
                        />
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="4">
                        <span>Haulage Rebate 20Ft:</span>
                      </v-col>
                      <v-col cols="2">
                        <input
                          type="number"
                          class="form-control"
                          v-model="selectedCompanyRate.haulage_rebate_20"
                        />
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="4">
                        <span>Haulage Rebate 40Ft:</span>
                      </v-col>
                      <v-col cols="2">
                        <input
                          type="number"
                          class="form-control"
                          v-model="selectedCompanyRate.haulage_rebate_40"
                        />
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="4" style="text-align: left">Planable:</v-col>
                      <v-col cols="2" style="text-align: center">
                        <input
                          type="checkbox"
                          class
                          id="planable"
                          v-model="selectedCompanyRate.planable"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="mb-3">
        <v-row justify="end">
          <v-btn
            @click="onSave"
            class="mr-2 font-weight-bold"
            color="primary"
            tile
            depressed
            >SAVE</v-btn
          >
          <v-btn
            @click="onDialogClose"
            dark
            class="ml-2 font-weight-bold"
            color="error"
            tile
            depressed
            >CLOSE</v-btn
          >
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import constant from "@/const";

export default {
  props: ["dialog", "company_rate"],

  data() {
    return {
      hasChange: false,
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 8000,

      customerRanks: [],
      selectedCompanyRate: null,
      selectedCustomerRank: null,
    };
  },

  created() {},
  mounted() {},

  watch: {
    dialog: function () {
      if (this.dialog) {
        this.customerRanks = [];
        this.selectedCompanyRate = null;
        this.selectedCustomerRank = null;
        this.listCustomerRanks();
        if (this.company_rate != null) {
          this.selectedCompanyRate = this.company_rate;
        }
      }
    },
  },

  methods: {
    /**
     * List customer ranks
     */
    listCustomerRanks() {
      this.$root.blockUImsg = "Loading...";
      this.$root.blockUIshow = true;
      this.$https
        .get("/api/company/rates/customer_ranks")
        .then((resp) => {
          if (resp.data.status == constant.RESPONSE_STATUS_OK) {
            this.customerRanks = resp.data.data;
          }
        })
        .catch((err) => {
          console.log("error: ", err);
        })
        .finally(() => {
          this.$root.blockUIshow = false;
        });
    },

    onDialogClose() {
      this.$emit("dialog-close", constant.DIALOG_COMPANY_RATES, this.hasChange);
    },

    onSave() {
      // load the blockui
      this.$root.blockUImsg = "saving customer rates...";
      this.$root.blockUIshow = true;

      this.$https
        .put(
          "/api/company/rates/" + this.selectedCompanyRate.company_id,
          this.selectedCompanyRate
        )
        .then((resp) => {
          if (resp.data.status == constant.RESPONSE_STATUS_OK) {
            this.showSnackbar = true;
            this.snackbarColor = "success";
            this.snackbarMsg = resp.data.msg;
            this.hasChange = true;
          } else {
            console.log(resp.data);
            this.showSnackbar = true;
            this.snackbarColor = "error";
            this.snackbarMsg = resp.data.msg;
          }
        })
        .catch((err) => {
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = err;
        })
        .finally(() => {
          this.$root.blockUIshow = false;
        });
    },
  },

  computed: {},
};
</script>

<style>
.checkbox-style {
  text-align: center;
}

.div-component {
  font-size: 12px;
  line-height: 26px;
  margin: auto;
}

.input-number {
  width: 100px;
  font-size: 12px;
  height: 26px;
}
</style>
